import NotFound from 'components/gruenland/organisms/not-found';

const YggdrasilNotFoundTastic = () => {
  return <NotFound />;
};

export default YggdrasilNotFoundTastic;
